export default __webpack_public_path__ + "static/media/demo-animation.3cc6f5e2.webm";